export default __webpack_public_path__ + "static/media/03_Read-a-book.c9a0e666.jpg";